import React, { useState } from "react";
import "./MobileTableCards.css";

// Mobile-only master→detail cards for wide admin tables. Each card shows a title
// + subtitle summary; tapping it expands the full field breakdown. Rendered right
// after the desktop <table> (which is hidden on phones via CSS), so the same data
// reads well on a phone without sideways-scrolling a 12-column grid.
//
// Props:
//   items       – array of row objects
//   getKey      – (item) => stable key
//   getTitle    – (item) => card headline
//   getSubtitle – (item) => small line under the title (optional)
//   getFields   – (item) => [ [label, value], ... ] shown when expanded
//   renderExtra – (item) => node rendered at the bottom of the expanded body
//                 (optional — e.g. a role <select> + Remove button)
export default function MobileTableCards({
  items,
  getKey,
  getTitle,
  getSubtitle,
  getFields,
  renderExtra,
}) {
  const [open, setOpen] = useState(() => new Set());
  const toggle = (k) =>
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(k) ? next.delete(k) : next.add(k);
      return next;
    });

  return (
    <div className="mtc-list">
      {items.map((it) => {
        const k = getKey(it);
        const isOpen = open.has(k);
        return (
          <div className={`mtc-card ${isOpen ? "open" : ""}`} key={k}>
            <button
              type="button"
              className="mtc-head"
              onClick={() => toggle(k)}
              aria-expanded={isOpen}
            >
              <span className="mtc-titles">
                <span className="mtc-title">{getTitle(it)}</span>
                {getSubtitle && <span className="mtc-sub">{getSubtitle(it)}</span>}
              </span>
              <span className="mtc-chevron" aria-hidden="true">
                {isOpen ? "▾" : "▸"}
              </span>
            </button>

            {isOpen && (
              <div className="mtc-body">
                {getFields(it).map(([label, value]) => (
                  <div className="mtc-row" key={label}>
                    <span className="mtc-label">{label}</span>
                    <span className="mtc-value">{value}</span>
                  </div>
                ))}
                {renderExtra && <div className="mtc-extra">{renderExtra(it)}</div>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
